<template>
    <div>
       <header id="header">
           <div class="top-part__header">
               <div class="container">
                   <router-link to="/" class="main-logo">
                       <img :src="logoSvg"
                            alt="Прокат фото, видео, кинотехники и оборудования в Минске, Фотопрокат MRental"
                            class="d-none d-lg-inline-block"/>
                       <img :src="logoSvg"
                            alt="Прокат фото, видео, кинотехники и оборудования в Минске, Фотопрокат MRental"
                            class="d-inline-block d-lg-none"/>
                   </router-link>

                   <div>
                       <div class="top-part__header-navigation">

                           <ul class="header-navigation-list">
                               <li v-for="item in navigation_link"
                               :class="{'active': active == item.id}">
                                   <router-link :to="item.link">
                                       {{item.title}}
                                   </router-link>
                               </li>
                           </ul>


                           <div class="align-items-center text-center">
                               <div class="align-items-center text-center">
                                   <a href="tel:+79774097239" id="7_977_409_72_39" class="font-500 color-text-white" v-bind:class="{ 'eye': !flagEye }">+7 977 409 72 39</a>
                                   <img class="eye-image" v-bind:class="{ 'eye-image-hide': flagEye }" @click="flagEye = !flagEye" src="/img/icons/eye.svg" alt="">
                               </div>
                           </div>
                       </div>

                       <div class="top-part__header-search">
                           <search-app></search-app>

                           <div class="d-flex align-items-center justify-content-end">
                               <router-link id="busket" to="/basket" class="mr-2 position-relative">
                                   <img src="/svg/basket.svg" alt="" class="icon-link">
                                   <span class="basket-count" v-if="store.state.basket_count">{{store.state.basket_count}}</span>
                               </router-link>
                               <div class="dividing-line"></div>
                               <div v-if="user">
                                   <div class="user-show">
                                       <img class="image" :src="'/storage/users/'+user.userData.id+'/'+user.userData.picture" alt="" v-if="user.userData.picture">
                                       <img class="image" src="/svg/user.svg" alt="" v-else>
                                       <p class="mb-0 d-none d-xl-block" v-if="user.userData.name">{{user.userData.name}}</p>
                                       <p class="mb-0 d-none d-xl-block" v-else>Пользователь</p>
                                       <img src="/svg/select-white.svg" alt="" class="mb-1">

                                       <div class="hover-box">
                                           <div>
                                               <router-link class="hover-box__item nowrap" to="/account">Личный кабинет</router-link>
                                               <div class="hover-box__item" @click="logout()">Выйти</div>
                                           </div>
                                       </div>
                                   </div>
                               </div>
                               <div class="ml-2" v-else>
                                   <router-link id="vhod" to="/login" class="color-text-white font-500">Войти</router-link>
                                   <span class="color-text-white font-500">/</span>
                                   <router-link id="reg" to="/register" class="color-text-white font-500">Зарегистрироваться</router-link>
                               </div>
                           </div>
                       </div>

                       <div class="top-part__header-mobile">
                           <div class="item" @click="showSearch()">
                               <img src="/svg/search.svg" alt="">
                           </div>

                           <div class="item">
                               <a href="tel:+79774097239"><img src="/svg/call.svg" alt=""></a>
                           </div>

                           <router-link to="/account" class="item" v-if="user">
                               <img src="/svg/account.svg" alt="">
                           </router-link>
                           <router-link to="/login" class="item" v-else>
                               <img src="/svg/account.svg" alt="">
                           </router-link>

<!--                           <div class="item" @click="showCategories()"><img src="/svg/categories.svg" alt=""></div>-->

                           <router-link id="busket" to="/basket" class="item position-relative">
                               <img src="/svg/basket.svg" alt="" class="icon-link">
                               <span class="basket-count" v-if="store.state.basket_count">{{store.state.basket_count}}</span>
                           </router-link>

                           <div class="item" v-if="!mobileMenu" @click="showMobileMenu()">
                               <img src="/svg/menu.svg" alt="">
                           </div>
                           <div class="item" v-if="mobileMenu" @click="closeMobileMenu()">
                               <img src="/svg/menu-close.svg" alt="">
                           </div>
                       </div>

                   </div>

               </div>
           </div>

           <div class="bottom-part__header" v-if="navigation_bottom">
               <div class="container">
                   <div class="menu-item menu-item-hover">
                       <router-link to="/catalog" class="category d-none d-xl-inline-block">
                           <img src="/svg/nav_icons/catalog.svg" alt="" class="mb-12">
                           <div class="h6 color-text-dark mb-0 font-500">Каталог</div>
                       </router-link>

                       <div @click="showCategories()" class="category d-xl-none d-inline-block">
                           <img src="/svg/nav_icons/catalog.svg" alt="" class="mb-12">
                           <div class="h6 color-text-dark mb-0 font-500">Каталог</div>
                       </div>
                   </div>

                   <div class="menu-item menu-item-hover" v-for="(item, i) in navigation_bottom" :key="i">
                       <router-link :to="item.url" class="category">
                           <img :src="'/svg/nav_icons/nav_' + item.slug + '.svg'" alt="" class="mb-12">
                           <div class="h6 color-text-grey mb-0 font-500">{{item.name}}</div>
                       </router-link>

                       <div class="menu-item__children" v-if="item.children != null && item.children.length > 0"
                       :style="menuPosition(i)">
                           <ul>
                               <li v-for="submenu in item.children">
                                   <router-link :to="submenu.url"><div class="h6">{{submenu.name}}</div></router-link>
                               </li>
                           </ul>
                       </div>
                   </div>

               </div>
           </div>

           <transition name="fade-right">
               <div id="menu--mobile" v-if="mobileMenu">
                   <div class="container">
                       <!--                   <div class="input-box">-->
                       <!--                       <input type="text" @keyup.enter="toSearch" v-model="search.search_text" placeholder="Поиск...">-->
                       <!--                       <img @click="toSearch()" src="/svg/search-mobile.svg" alt="">-->
                       <!--                   </div>-->

                       <nav>
                           <div @click="showCategories()" :class="{'active': active === 8}">
                               <a href="#" class="catalog"><img src="/svg/catalog.svg" alt="">Каталог</a>
                           </div>
                           <div v-for="item in navigation_link"
                                :class="{'active': active === item.id}">
                               <router-link :to="item.link">{{item.title}}</router-link>
                           </div>
                           <div v-if="!user" :class="{'active': active === 9}">
                               <router-link to="/register">Регистрация</router-link>
                           </div>
                           <div v-else @click="logout()"><span>Выход</span></div>
                       </nav>

                       <div class="text-center">
                           <a href="tel:+79774097239">+7 977 409 72 39</a>
                       </div>

                       <div class="social">
                           <a target="_blank" href="https://t.me/+79774097239" class="ico-social">
                               <img src="/svg/telegram_color.svg">
                           </a>
<!--                           <a target="_blank" href="https://www.instagram.com/myrental.by/" class="ico-social">-->
<!--                               <img src="/svg/insta_color.svg">-->
<!--                           </a>-->
                           <a target="_blank" :href="viber_attrs + '79774097239'" class="ico-social">
                               <img src="/svg/viber_color.svg">
                           </a>
<!--                           <a target="_blank"  href="https://api.whatsapp.com/send?phone=+79774097239" class="ico-social">-->
<!--                               <img src="/svg/whatsapp_color.svg">-->
<!--                           </a>-->
                       </div>
                   </div>
               </div>
           </transition>

       </header>

        <div id="header-after-scroll">
            <div class="container">
                <ul class="header-navigation-list">
                    <li><router-link to="/">Главная</router-link></li>
                    <li v-for="item in navigation_link"
                        :class="{'active': active == item.id}">
                        <router-link :to="item.link">
                            {{item.title}}
                        </router-link>
                    </li>
                </ul>

                <div class="phone">
                    <a href="tel:+79774097239" class="font-500 color-text-white d-block">+7 977 409 72 39</a>
                </div>


                <div class="d-flex align-items-center justify-content-end">
                    <div class="mr-3 icon-link cursor-pointer" @click="showSearch()">
                        <img src="/svg/search.svg" alt="">
                    </div>
                    <router-link id="busket" to="/basket" class="mr-2 position-relative">
                        <img src="/svg/basket.svg" alt="" class="icon-link">
                        <span class="basket-count" v-if="store.state.basket_count">{{store.state.basket_count}}</span>
                    </router-link>

                    <div class="ml-2">
                        <div v-if="user">
                            <div class="user-show">
                                <img class="image" :src="'/storage/users/'+user.userData.id+'/'+user.userData.picture" alt="" v-if="user.userData.picture">
                                <img class="image" src="/svg/user.svg" alt="" v-else>
                                <p class="mb-0" v-if="user.userData.name">{{user.userData.name}}</p>
                                <p class="mb-0" v-else>Пользователь</p>
                                <img src="/svg/select-white.svg" alt="" class="mb-1">

                                <div class="hover-box">
                                    <div>
                                        <router-link class="hover-box__item nowrap" to="/account">Личный кабинет</router-link>
                                        <div class="hover-box__item" @click="logout()">Выйти</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <router-link id="vhod" v-else to="/login"  class="color-text-white font-500">Войти</router-link>
                    </div>
                </div>

            </div>
        </div>


        <div v-if="active_search" class="search-scroll">
            <div class="search-scroll-container">
                <div class="container">
                    <search-app></search-app>
                    <div class="ml-3 icon-link cursor-pointer" @click="closeSearch()"><img src="/svg/close.svg" alt=""></div>
                </div>
            </div>

            <div class="overlay" @click="closeSearch()"></div>
        </div>


        <add-basket-modal></add-basket-modal>

        <transition name="fade-left">
            <catalog-categories class="mobile" v-if="windowWidth < 1200" :class="{'active': categories_mobile}" @close_categories="closeCategories"/>
        </transition>

    </div>
</template>


<script>
    import store from '../services/data';
    import filter from '../services/filter';

    export default {
        data() {
            return {
                flagEye: false,
                store: store,
                filter: filter,
                active: null,
                navigation_link: [
                    {
                        id: 1,
                        title: 'Каталог',
                        link: '/catalog'
                    },
                    {
                        id: 2,
                        title: 'Правила проката',
                        link: '/rules'
                    },
                    {
                        id: 3,
                        title: 'Услуги',
                        link: '/services'
                    },
                    {
                        id: 4,
                        title: 'Доставка и оплата',
                        link: '/delivery'
                    },
                    {
                        id: 5,
                        title: 'Акции',
                        link: '/promotions'
                    },
                    {
                        id: 6,
                        title: 'Проекты',
                        link: '/projects'
                    },
                    {
                        id: 7,
                        title: 'Контакты',
                        link: '/contact'
                    },
                ],

                active_search: false,
                search: {
                    search_text: null,
                    page_products: 0,
                    page_news: 0,
                    page_services: 0,
                    page_shares: 0,
                    page_projects: 0,
                    page_rules: 0,
                },

                categories_mobile: false,

                windowWidth: null,

                mobileMenu: false,
                viber_attrs: 'viber://chat?number=',

                logoSvg: require('./../../svg/logomrental.svg'),
            }
        },

        watch: {
            $route() {
                this.checkActive();
                this.closeSearch();
                this.closeMobileMenu();
                if(window.innerWidth < 1200) {
                    this.closeCategories();
                    this.checkCatalogRoute();
                }
            }
        },

        computed: {
            navigation_bottom() {
                return this.$store.getters.getTopCategories;
            },
            user() {
                return this.$store.getters.getUser;
            }
        },

        created() {
            this.checkActive();
            this.store.getBasketCount();
        },

        mounted() {
            this.windowWidth = window.innerWidth;
            window.addEventListener('resize', this.handleWindowResize);
            if (/Android|webOS|Opera Mini/i.test(navigator.userAgent)) {
                this.viber_attrs = 'viber://chat?number=';
            } else {
                this.viber_attrs = 'viber://chat?number=+';
            }
        },

        methods: {
            checkActive() {
                if (this.$route.name === 'pages-catalog') this.active = 1;
                else if (this.$route.name === 'pages-rules' || this.$route.name === 'pages-rules-show') this.active = 2;
                else if (this.$route.name === 'pages-services' || this.$route.name === 'pages-services-show') this.active = 3;
                else if (this.$route.name === 'pages-delivery') this.active = 4;
                else if (this.$route.name === 'pages-shares' || this.$route.name === 'pages-shares-show') this.active = 5;
                else if (this.$route.name === 'pages-projects' || this.$route.name === 'pages-projects-show') this.active = 6;
                else if (this.$route.name === 'pages-contacts') this.active = 7;
                else if (this.$route.name.match('^pages-catalog')) this.active = 8;
                else if (this.$route.name === 'pages-register') this.active = 9;
                else this.active = null;
            },

            menuPosition(i) {
                if(i < 4) return 'left: -2px';
                if(i > 3) return 'right: -2px';
            },

            showSearch() {
                this.active_search = true;
                document.getElementsByTagName('body')[0].style.overflow = 'hidden'

            },
            closeSearch() {
                this.active_search = false;
                document.getElementsByTagName('body')[0].style.overflow = 'visible'
            },

            logout() {
                let url = '/api/logout';
                axios.post(url, {}, {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem('token')
                        }
                    })
                    .then(response => {
                        if (response.status == 200) {
                            localStorage.removeItem('token');
                            window.location.pathname = "/";
                        }
                    });
            },

            toSearch() {
                if(this.search.search_text) {
                    this.$router.push({ path: '/search?search=' + this.search.search_text });
                    this.search.search_text = null;
                }
            },

            showMobileMenu() {
                this.mobileMenu = true;
                document.body.style.overflow = 'hidden';
            },
            closeMobileMenu() {
                this.mobileMenu = false;
                document.body.style.overflow = 'auto';
            },

            handleWindowResize() {
                this.windowWidth = window.innerWidth;
                if(window.innerWidth > 991) this.mobileMenu = false;
                if(window.innerWidth > 1200) this.closeCategories();
            },

            showCategories() {
                this.categories_mobile = true;
                document.body.style.overflow = 'hidden'
            },
            closeCategories() {
                this.categories_mobile = false;
                document.body.style.overflow = 'visible';
            },

            checkCatalogRoute() {
                //if(this.filter.state.prev_item && this.$route.name.includes('catalog')) this.showCategories();
            }
        }
    }
</script>
